import { render, staticRenderFns } from "./PurchaseOrder.vue?vue&type=template&id=05610a68&scoped=true"
import script from "./PurchaseOrder.vue?vue&type=script&lang=js"
export * from "./PurchaseOrder.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrder.vue?vue&type=style&index=0&id=05610a68&prod&lang=stylus&scoped=true"
import style1 from "./PurchaseOrder.vue?vue&type=style&index=1&id=05610a68&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05610a68",
  null
  
)

export default component.exports